import apiFetch from '../apiFetch'

export default function (userId, processingAgencyId, token) {
  return apiFetch({ endPoint: `AssingUserProcessingAgency/${processingAgencyId}/${userId}`, method: 'POST', token: token })
}
